import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { Link } from "react-router-dom";

const Headwrapper = styled.header`
  display: flex;
  width: 100%;
  height: 60px;
  min-width: 1200px;
  align-items: center;
  background-color: #0f0f0f;
  padding: 16px;
  box-sizing: border-box;
  position: fixed;
  z-index: 9998;

  & > img {
    width: 24px;
    height: 24px;
    margin: 2px 12px 0px 0px;
    cursor: pointer;
  }

  & > a {
    font-weight: 700;
    font-size: 20px;
    line-height: 20.9px;
    letter-spacing: 0;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
  }

  @media (max-width: 426px) {
    min-width: 100%;
    width: 100%;

    & > a {
      font-size: 16px;
    }
  }
`;

//햄버거 메뉴
const HamburgerField = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  height: 100vh;
  background-color: #1a1b20;
  padding: 104px 24px 0px 24px;
  box-sizing: border-box;
  position: relative;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(${(props) => (props.open ? "0" : "-100%")});
  opacity: ${(props) => (props.open ? 1 : 0)};
  transition: transform 0.3s ease, opacity 0.3s ease;
  pointer-events: ${(props) => (props.open ? "auto" : "none")};

  z-index: 9999;
  position: fixed;

  & > button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background-color: #495057;
    border-radius: 16px;
    border: none;
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
  }
  & > button > img {
    width: 24px;
    height: 24px;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-weight: 700;
    font-size: 20px;
    line-height: 20.9px;
    letter-spacing: 0;
    color: #fff;
    text-shadow: -2px 2px 0 #bd1236;
  }
`;

const HamburgerTech = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 272px;
  height: 56px;
  background-color: #1a1b20;
  cursor: pointer;
  transition: background-color 0.2s ease;
  text-decoration: none;
  color: inherit;

  &:hover {
    background-color: #495057;
    border-radius: 8px;
  }
`;

function Header() {
  const [techniques, setTechniques] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    axios
      .get(
        `https://jiujitsu-json-data.s3.ap-northeast-2.amazonaws.com/jiujitsu/jiujitsu_techniques.json?v=${Date.now()}`
      )
      .then((res) => {
        setTechniques(res.data);
      });
  }, []);

  const techniquesList = techniques.map((data, index) => {
    return (
      <HamburgerTech
        key={index}
        to={`/tech/${data.techniqueName}`}
        onClick={() => setIsOpen(false)}
      >
        {data.techniqueName}
      </HamburgerTech>
    );
  });

  return (
    <header>
      <Headwrapper>
        <img
          src="/hamburger.png"
          alt="hamburger"
          onClick={() => setIsOpen(true)}
        ></img>
        <Link
          to="/"
          onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
        >
          BJJ Archive
        </Link>
      </Headwrapper>

      <div className="headspace"></div>

      <div
        className={`overlay ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      <HamburgerField open={isOpen}>
        <button onClick={() => setIsOpen(false)}>
          <img src="/arrow.png" alt="back" />
        </button>
        <div>{techniquesList}</div>
      </HamburgerField>
    </header>
  );
}

export default Header;
